import { render, staticRenderFns } from "./msisdnRechargeHistory.vue?vue&type=template&id=b613d282&scoped=true&"
import script from "./msisdnRechargeHistory.vue?vue&type=script&lang=js&"
export * from "./msisdnRechargeHistory.vue?vue&type=script&lang=js&"
import style0 from "./msisdnRechargeHistory.vue?vue&type=style&index=0&id=b613d282&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613d282",
  null
  
)

export default component.exports